import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertDialog({
  language,
  open,
  onClose,
  title,
  body,
  onOk,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{
          direction: language == "english" ? "ltr" : "rtl",
          textAlign: language == "english" ? "left" : "right",
        }}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {body
              ? body.split(";").map((p) => (
                  <>
                    {p}
                    <br />
                  </>
                ))
              : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {language == "english" ? "No" : "لا"}
          </Button>
          <Button onClick={onOk} color="primary" autoFocus>
            {language == "english" ? "Yes" : "نعم"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
